import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ContasAPagarComponent } from './pages/financeiro/components/contas-a-pagar.component/contas-a-pagar.component';
import { HomeComponent } from './home/home';
import { ClientesComponent } from './pages/cadastro/components/clientes.component/clientes.component';
import { FornecedoresComponent } from './pages/cadastro/components/fornecedores.component/fornecedores.component';
import { ServicosComponent } from './pages/cadastro/components/servicos.component/servicos.component';
import { VendedoresComponent } from './pages/cadastro/components/vendedores.component/vendedores.component';
import { VendedoresManutencaoComponent } from './pages/cadastro/components/vendedores.component/vendedores-manutencao.component/vendedores-manutencao.component';
import { ParametrosComponent } from './pages/parametros/components/parametros.component/parametros.component';
import { GrupoComponent } from './pages/parametros/components/grupo.component/grupo.component';
import { GrupoManutencaoComponent } from './pages/parametros/components/grupo.component/grupo-manutencao.component/grupo-manutencao.component';
import { SubgrupoComponent } from './pages/parametros/components/subgrupo.component/subgrupo.component';
import { ParametrosManutencaoComponent } from './pages/parametros/components/parametros.component/parametros-manutencao.component/parametros-manutencao.component';
import { AuthGuard } from './guards/auth.guard';
import { Homepage } from './home/homepage/homepage';
import { FornecedoresManutencaoComponent } from './pages/cadastro/components/fornecedores.component/fornecedores-manutencao.component/fornecedores-manutencao.component';
import { ClientesManutencaoComponent } from './pages/cadastro/components/clientes.component/clientes-manutencao.component/clientes-manutencao.component';
import { ClienteVendasComponent } from './pages/cadastro/components/clientes.component/cliente-vendas.component/cliente-vendas.component';
import { SubgrupoManutencaoComponent } from './pages/parametros/components/subgrupo.component/subgrupo-manutencao.component/subgrupo-manutencao.component';
import { ContasAPagarManutencaoComponent } from './pages/financeiro/components/contas-a-pagar.component/contas-a-pagar-manutencao.component/contas-a-pagar-manutencao.component';
import { ProdutosHistoricoPrecosComponent } from './pages/cadastro/components/produtos.component/produtos-historico-precos.component/produtos-historico-precos.component';
import { ProdutosComponent } from './pages/cadastro/components/produtos.component/produtos.component';
import { ProdutosManutencaoComponent } from './pages/cadastro/components/produtos.component/produtos-manutencao.component/produtos-manutencao.component';
import { OrcamentosComponent } from './pages/financeiro/components/orcamentos.component/orcamentos.component';
import { OrcamentoItensComponent } from './pages/financeiro/components/orcamentos.component/orcamento-itens.component/orcamento-itens.component';
import { PontoDeVendaComponent } from './pages/financeiro/components/ponto-de-venda.component/ponto-de-venda.component';
import { pdvSaidaGuard } from './guards/pdv-saida.guard';
import { VendasComponent } from './pages/financeiro/components/vendas.component/vendas.component';
import { ContasAReceberComponent } from './pages/financeiro/components/contas-a-receber.component/contas-a-receber.component';
import { ServicosManutencaoComponent } from './pages/cadastro/components/servicos.component/servicos-manutencao.component/servicos-manutencao.component';
import { AgendamentoComponent } from './modulos_extras/marmoraria/agendamento.component/agendamento.component';
import { MenuComponent } from './pages/sistema/menu/menu.component/menu.component';
import { MenuManutencaoComponent } from './pages/sistema/menu/menu.component/menu-manutencao.component/menu-manutencao.component';
import { UsuarioManutencaoComponent } from './pages/login/usuario-manutencao.component/usuario-manutencao.component';
import { ContasAReceberManutencaoComponent } from './pages/financeiro/components/contas-a-receber.component/contas-a-receber-manutencao.component/contas-a-receber-manutencao.component';
import { AgendamentoManutencaoComponnet } from './modulos_extras/marmoraria/agendamento.component/agendamento-manutencao.componnet/agendamento-manutencao.componnet';
import { VisitaRealizadaComponent } from './modulos_extras/marmoraria/visita-realizada.component/visita-realizada.component';
import { RelatorioOrcamentosComponent } from './pages/relatorios/relatorio-orcamentos.component/relatorio-orcamentos.component';
import { RelatorioContasAPagarDetalhadoComponent } from './pages/relatorios/relatorio-contas-a-pagar-detalhado.component/relatorio-contas-a-pagar-detalhado.component';
import { RelatorioContasAPagarAgrupadoComponent } from './pages/relatorios/relatorio-contas-a-pagar-agrupado.component/relatorio-contas-a-pagar-agrupado.component';
import { RelatorioVendasComponent } from './pages/relatorios/relatorio-vendas.component/relatorio-vendas.component';
import { RelatorioMovimentoFinanceiroComponent } from './pages/relatorios/relatorio-movimento-financeiro.component/relatorio-movimento-financeiro.component';
import { RelatorioProdutosVendidosComponent } from './pages/relatorios/relatorio-produtos-vendidos.component/relatorio-produtos-vendidos.component';
import { InadimplentesComponent } from './pages/financeiro/components/inadimplentes.component/inadimplentes.component';
import { CargosComponent } from './pages/cadastro/components/cargos.component/cargos.component';
import { CargoManutencaoComponent } from './pages/cadastro/components/cargos.component/cargo-manutencao.component/cargo-manutencao.component';
import { FuncionariosComponent } from './pages/cadastro/components/funcionarios.component/funcionarios.component';
import { FuncionariosManutencaoComponent } from './pages/cadastro/components/funcionarios.component/funcionarios-manutencao.component/funcionarios-manutencao.component';
import { FuncionarioSalarioComponent } from './pages/cadastro/components/funcionarios.component/funcionario-salario.component/funcionario-salario.component';
import { ControleProducaoComponent } from './pages/producao/controle-producao.component/controle-producao.component';
import { ControleProducaoManutencaoComponent } from './pages/producao/controle-producao-manutencao.component/controle-producao-manutencao.component';
import { PermissoesUsuarioComponent } from './pages/sistema/permissoes-usuario.component/permissoes-usuario.component';
import { PermissoesUsuarioManutencaoComponent } from './pages/sistema/permissoes-usuario-manutencao.component/permissoes-usuario-manutencao.component';
import { UsuarioAdminManutencaoComponent } from './pages/sistema/usuario-admin-manutencao.component/usuario-admin-manutencao.component';


export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard],
        children: [
            //CADASTROS
            {path: 'cadastro-cliente', component: ClientesComponent},
            {path: 'cadastro-cliente-manutencao', component: ClientesManutencaoComponent},
            {path: 'cadastro-cliente-manutencao/:id', component: ClientesManutencaoComponent},
            {path: 'cadastro-cliente-vendas/:id', component: ClienteVendasComponent},
            {path: 'cadastro-fornecedor', component: FornecedoresComponent},
            {path: 'cadastro-fornecedor-manutencao', component: FornecedoresManutencaoComponent},
            {path: 'cadastro-fornecedor-manutencao/:id', component: FornecedoresManutencaoComponent},
            {path: 'cadastro-servico', component: ServicosComponent},
            {path: 'cadastro-servico-manutencao', component: ServicosManutencaoComponent },
            {path: 'cadastro-servico-manutencao/:id', component: ServicosManutencaoComponent },
            {path: 'cadastro-vendedor', component: VendedoresComponent},
            {path: 'cadastro-vendedor-manutencao', component: VendedoresManutencaoComponent},
            {path: 'cadastro-vendedor-manutencao/:id', component: VendedoresManutencaoComponent},
            {path: 'cadastro-cargo', component: CargosComponent},
            {path: 'cadastro-cargo-manutencao', component: CargoManutencaoComponent},
            {path: 'cadastro-cargo-manutencao/:id', component: CargoManutencaoComponent},
            {path: 'cadastro-funcionario', component: FuncionariosComponent},
            {path: 'cadastro-funcionario-manutencao', component: FuncionariosManutencaoComponent},
            {path: 'cadastro-funcionario-manutencao/:id', component: FuncionariosManutencaoComponent},
            {path: 'cadastro-funcionario-salario/:id', component: FuncionarioSalarioComponent},
            
            //PRODUCAO
            {path: 'producao-controle', component: ControleProducaoComponent},
            {path: 'producao-controle-manutencao/:id', component: ControleProducaoManutencaoComponent},

          
            {path: 'produto-cadastro', component: ProdutosComponent},
            {path: 'produto-cadastro-manutencao', component: ProdutosManutencaoComponent},
            {path: 'produto-cadastro-manutencao/:id', component: ProdutosManutencaoComponent},
            {path: 'produto-historico-preco/:id', component: ProdutosHistoricoPrecosComponent},
            
  
            //PARAMETROS
            { path: 'parametro-despesa-grupo', component: GrupoComponent },
            { path: 'parametro-despesa-grupo-manutencao', component: GrupoManutencaoComponent },
            { path: 'parametro-despesa-grupo-manutencao/:id', component: GrupoManutencaoComponent },
            
            { path: 'parametro-despesa-subgrupo', component: SubgrupoComponent },
            { path: 'parametro-despesa-subgrupo-manutencao', component: SubgrupoManutencaoComponent },
            { path: 'parametro-despesa-subgrupo-manutencao/:id', component: SubgrupoManutencaoComponent },
            
            { path: 'parametro-parametros', component: ParametrosComponent },
            { path: 'parametro-parametros-manutencao', component: ParametrosManutencaoComponent },
            { path: 'parametro-parametros-manutencao/:id', component: ParametrosManutencaoComponent },


            { path: 'relatorios-dashboard', component: DashboardComponent },
            { path: 'relatorios-orcamentos', component: RelatorioOrcamentosComponent },
            { path: 'relatorios-contas-a-pagar-detalhado', component: RelatorioContasAPagarDetalhadoComponent },
            { path: 'relatorios-contas-a-pagar-agrupado', component: RelatorioContasAPagarAgrupadoComponent },
            { path: 'relatorios-vendas', component: RelatorioVendasComponent },
            { path: 'relatorios-movimento-financeiro', component: RelatorioMovimentoFinanceiroComponent },
            { path: 'relatorios-produtos-vendidos', component: RelatorioProdutosVendidosComponent },

            { path: 'financeiro-conta-a-pagar', component: ContasAPagarComponent },
            { path: 'financeiro-conta-a-receber', component: ContasAReceberComponent },
            { path: 'financeiro-inadimplentes', component: InadimplentesComponent },
            { path: 'financeiro-conta-a-pagar-manutencao', component: ContasAPagarManutencaoComponent },
            { path: 'financeiro-conta-a-pagar-manutencao/:id', component: ContasAPagarManutencaoComponent },
            { path: 'financeiro-conta-a-receber-manutencao', component: ContasAReceberManutencaoComponent },
            { path: 'financeiro-conta-a-receber-manutencao/:id', component: ContasAReceberManutencaoComponent },
           


            { path: 'venda-orcamento', component: OrcamentosComponent },
            { path: 'venda-venda', component: VendasComponent },
            // PDV: publicar (menu/permissão) somente após o gate G1 do plano 2026-10-22-ponto-de-venda-venda-rapida.
            { path: 'venda-ponto-de-venda', component: PontoDeVendaComponent, canDeactivate: [pdvSaidaGuard] },
            { path: 'venda-orcamento-item', component: OrcamentoItensComponent },
            { path: 'venda-orcamento-item', component: OrcamentoItensComponent },
            { path: 'venda-orcamento-item/:idCliente/conversao', component: OrcamentoItensComponent },
            { path: 'venda-orcamento-item/:idOrcamento', component: OrcamentoItensComponent },
            




            //FISCAL
            {
              path: 'fiscal',
              loadChildren: () => import('./pages/fiscal/fiscal.routes').then(m => m.FISCAL_ROUTES)
            },
            // Link antigo (item de menu / favorito) apontava para a rota plana; preserva o destino.
            { path: 'fiscal-nota', redirectTo: 'fiscal/notas', pathMatch: 'full' },





            
            { path: 'sistema-menu', component: MenuComponent },
            { path: 'sistema-menu-manutencao', component: MenuManutencaoComponent },
            { path: 'sistema-menu-manutencao/:id', component: MenuManutencaoComponent },
            { path: 'sistema-permissoes', component: PermissoesUsuarioComponent },
            { path: 'sistema-permissoes-manutencao/:id', component: PermissoesUsuarioManutencaoComponent },
            { path: 'sistema-usuario-admin-manutencao', component: UsuarioAdminManutencaoComponent },
            { path: 'sistema-usuario-admin-manutencao/:id', component: UsuarioAdminManutencaoComponent },
            { path: 'homepage', component: Homepage },
            { path: 'usuario-manutencao', component: UsuarioManutencaoComponent },
        




            { path: 'agendamento', component: AgendamentoComponent },
            { path: 'agendamento/:id', component: AgendamentoComponent },
            { path: 'agendamento-manutencao', component: AgendamentoManutencaoComponnet },
            { path: 'agendamento-manutencao/:id', component: AgendamentoManutencaoComponnet },
            { path: 'visita-realizada', component: VisitaRealizadaComponent },

           //--------------------------------------------------------

            //ESTOQUE
            {
              path: 'estoque',
              loadChildren: () => import('./pages/estoque/estoque.routes').then(m => m.ESTOQUE_ROUTES)
            },

            { path: '', redirectTo: 'homepage', pathMatch: 'full' }
        ]
    },
    { path: '', redirectTo: '/login', pathMatch: 'full' }
];
